export default __webpack_public_path__ + "static/media/universe.b3b6015e.mp4";